import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function PhonelinkSetupIcon(props: IconProps) {
    return <Icon {...props} iconKey={"phonelink_setup"}/>
}
